// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface LoginResponseInterface {
  // empty interface
}

export interface LoginResponse extends LoginResponseInterface {
  isPasswordResetRequired?: boolean;
  isNewPasswordRequired: boolean;
  isSmsMfaRequired: boolean;
  isMfaSetupRequired?: boolean;
  mfaTypeSupported?: MfaType[];
  sessionId: string;
  email: string;
  userId: string;
  tokens: LoginTokens;
  codeDeliveryDestination: string;
}

export interface LoginTokens {
  idToken: string;
  accessToken: string;
  expiresIn: number;
  refreshToken: string;
}

export interface RefreshTokenRequest {
  email: string;
  refreshToken: string;
}

export interface DecodedJWT {
  address: {
    formatted: { country: string; locality: string; postal_code: string; street_address: string };
  };
  aud: string;
  auth_time: number;
  'cognito:username': string;
  'custom:WebsiteId': string;
  'custom:LegacyUserId': string;
  email: string;
  email_verified: boolean;
  event_id: string;
  exp: number;
  iat: number;
  iss: string;
  jti: string;
  name: string;
  origin_jti: string;
  phone_number_verified: boolean;
  sub: string;
  token_use: string;
  role: string[] | string;
}

export interface SmsChallengeRequest {
  email: string;
  mfaCode: string;
  sessionId: string;
}

export enum MfaType {
  SMS = 'SMS',
  APP = 'APP',
}
